import React from 'react';
import {FormikErrors, withFormik} from 'formik';

import PropTypes from 'prop-types';
import {FieldShape} from 'commons/shapes';
import {Messages} from 'commons/constants';
import {InferPropTypes} from 'commons/types/Types';
import {formValidator, setDefaultValue} from 'commons/utils/Functions';
import {RealOwnerServiceRequest} from 'commons/models';
import InnerFormRealOwnerPersonalInfo from './InnerFormRealOwnerPersonalInfo';

RealOwnerPersonalInfoForm.propTypes = {
    viewId: PropTypes.number.isRequired,
    viewKey: PropTypes.string.isRequired,
    fieldHandler: PropTypes.func.isRequired,
    submitHandler: PropTypes.func.isRequired,
    fields: PropTypes.arrayOf(PropTypes.shape(FieldShape).isRequired).isRequired,
    auxRealownerInfo: PropTypes.any,
};

const FormControl = withFormik<
    InferPropTypes<typeof RealOwnerPersonalInfoForm.propTypes>,
    RealOwnerServiceRequest
>({
    mapPropsToErrors: () => {
        return {
            expedientId: '',
            workflowId: '',
            viewId: '',
            viewFatherId: '',
            kycId: '',
            personTypeKey: '',
            rfc: '',
            name: '',
            lastName: '',
            secondLastName: '',
            birthDate: '',
            rol: '',
            fatherKycId: '',
            curp: '',
            classificationPersonKey: '',
            countryOrigin: '',
            occupationDescription: '',
            occupationKey: '',
            email: '',
            foreignCitizen: '',
            economicActivity: '',
            phoneNumber: '',
            nif: '',
            countryNationality: '',
            gender: '',
            birthState: '',
        };
    },
    mapPropsToValues: (props) => {
        const {auxRealownerInfo} = props;
        if (auxRealownerInfo) {
            return {
                expedientId: setDefaultValue(auxRealownerInfo.expedientId, 0),
                workflowId: setDefaultValue(auxRealownerInfo.workflowId, 0),
                viewId: setDefaultValue(auxRealownerInfo.viewId, 0),
                viewFatherId: setDefaultValue(auxRealownerInfo.viewFatherId, 0),
                kycId: setDefaultValue(auxRealownerInfo.kycId, 0),
                personTypeKey: setDefaultValue(auxRealownerInfo.personTypeKey, ''),
                rfc: setDefaultValue(auxRealownerInfo.rfc, ''),
                name: setDefaultValue(auxRealownerInfo.name, ''),
                lastName: setDefaultValue(auxRealownerInfo.lastName, ''),
                secondLastName: setDefaultValue(auxRealownerInfo.secondLastName, ''),
                birthDate: setDefaultValue(auxRealownerInfo.birthDate, ''),
                rol: setDefaultValue(auxRealownerInfo.rol, ''),
                fatherKycId: setDefaultValue(auxRealownerInfo.fatherKycId, 0),
                curp: setDefaultValue(auxRealownerInfo.curp, ''),
                classificationPersonKey: setDefaultValue(auxRealownerInfo.classificationPersonKey,''),
                countryOrigin: setDefaultValue(auxRealownerInfo.countryOrigin, ''),
                occupationDescription: setDefaultValue(auxRealownerInfo.occupationDescription, ''),
                occupationKey: setDefaultValue(auxRealownerInfo.occupationKey, ''),
                email: setDefaultValue(auxRealownerInfo.email, ''),
                phoneNumber: setDefaultValue(auxRealownerInfo.phoneNumber, ''),
                foreignCitizen: setDefaultValue(auxRealownerInfo.foreignCitizen, false),
                economicActivity: setDefaultValue(auxRealownerInfo.economicActivity, ''),
                nif: setDefaultValue(auxRealownerInfo.nif, ''),
                gender: setDefaultValue(auxRealownerInfo.gender, ''),
                birthState: setDefaultValue(auxRealownerInfo.birthState, ''),
                countryNationality: setDefaultValue(auxRealownerInfo.countryNationality, ''),
                validationResult: !auxRealownerInfo.foreignCitizen,
            };
        } else {
            return {
                expedientId: 0,
                workflowId: 0,
                viewId: 0,
                viewFatherId: 0,
                kycId: 0,
                personTypeKey: '',
                rfc: '',
                name: '',
                lastName: '',
                secondLastName: '',
                birthDate: '',
                rol: '',
                fatherKycId: 0,
                curp: '',
                classificationPersonKey: '',
                countryOrigin: '',
                occupationDescription: '',
                occupationKey: '',
                email: '',
                phoneNumber: '',
                foreignCitizen: false,
                economicActivity: '',
                nif: '',
                gender: '',
                birthState: '',
                countryNationality: '',
                validationResult: false,
            };
        }
    },
    validateOnBlur: true,
    validateOnChange: true,
    validate: (values: RealOwnerServiceRequest, props) => {
        const errors: FormikErrors<RealOwnerServiceRequest> = {};
        formValidator(props.fields, errors, values);
        if (!values.foreignCitizen) {
            if (values.curp && !values.validationResult) {
                errors.curp = Messages.CURP_VALIDATION_REQUIRED;
            }
        }
        return errors;
    },
    handleSubmit: (values, actions) => {
        actions.setSubmitting(false);
        actions.props.submitHandler({...values});
    },
})(InnerFormRealOwnerPersonalInfo);
function RealOwnerPersonalInfoForm(
    props: InferPropTypes<typeof RealOwnerPersonalInfoForm.propTypes>
) {
    const {submitHandler, fields, auxRealownerInfo, fieldHandler, viewId, viewKey} = props;

    /* eslint-disable react/jsx-handler-names */
    return (
        <FormControl
            fields={fields}
            viewId={viewId}
            viewKey={viewKey}
            fieldHandler={fieldHandler}
            submitHandler={submitHandler}
            auxRealownerInfo={auxRealownerInfo}
        />
    );
}

export default RealOwnerPersonalInfoForm;
